module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/doctors/noimage_s100x100-ee80d27176f30c2c4b454ac0b878d0f3.jpg";